import { render } from "./SignUpView.vue?vue&type=template&id=8ca3fb04&scoped=true"
import script from "./SignUpView.vue?vue&type=script&lang=js"
export * from "./SignUpView.vue?vue&type=script&lang=js"

import "./SignUpView.vue?vue&type=style&index=0&id=8ca3fb04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ca3fb04"]])

export default __exports__